import useGetInternalWidgetConfig from '@hooks/api/queries/useGetInternalWidgetConfig';
import { WidgetTypeDeviceList } from '@src/types/Widget';
import { GridRowId } from '@mui/x-data-grid-pro';
import { pcsSx } from '@src/components/_shared/sxStyles/Datatable/deviceTableList';
import { usePCSWidget } from './PCSWidgetProvider';
import WidgetDeviceList from '../WidgetDeviceList';

function PCSModuleContainer({
  pcsId,
  unitControllerId,
  unitControllerEngineeringId,
}: {
  pcsId: GridRowId;
  unitControllerId: string;
  unitControllerEngineeringId: string;
}) {
  const { widgetId, isUnitScope } = usePCSWidget();

  const { data: widgetConfig } =
    useGetInternalWidgetConfig<WidgetTypeDeviceList>(
      `${widgetId}ModuleList`,
      {
        sourceDeviceId: pcsId as string,
        ...(isUnitScope
          ? {
              unitControllerId,
              unitControllerEngineeringId,
            }
          : {}),
      },
      {
        queryKeys: [pcsId as string, unitControllerId],
        enabled: !!pcsId && !!unitControllerId && !!unitControllerEngineeringId,
      },
    );

  return (
    <div>
      {widgetConfig && (
        <WidgetDeviceList
          id={`module_${pcsId}_${unitControllerId}_${unitControllerEngineeringId}`}
          widgetConfig={widgetConfig}
          sx={pcsSx.detailDataTable}
          {...(isUnitScope
            ? {
                unitControllerId,
                unitControllerEngineeringId,
              }
            : {})}
        />
      )}
    </div>
  );
}

export default PCSModuleContainer;
